<div class="page">
  <header class="page-header">
    <h1 class="page-title">Following</h1>
    <p class="page-subtitle">Stay updated on ideas you care about</p>
  </header>

  <!-- <section class="notification-prefs" [class.prefs-open]="prefsExpanded">
    <h2 class="prefs-heading">
      <button
        type="button"
        class="prefs-trigger"
        (click)="togglePrefsSection()"
        [attr.aria-expanded]="prefsExpanded"
        aria-controls="following-prefs-panel"
        id="following-prefs-label"
      >
        <span class="prefs-heading-text">Notification Preferences</span>
        <span class="prefs-chevron" aria-hidden="true">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
            <path d="M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"/>
          </svg>
        </span>
      </button>
    </h2>
    <div
      class="prefs-collapse"
      id="following-prefs-panel"
      role="region"
      aria-labelledby="following-prefs-label"
      [attr.hidden]="prefsExpanded ? null : ''"
    >
      <div class="prefs-collapse-inner">
        <div class="prefs-list">
      <div class="pref-item">
        <span class="pref-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
            <path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"/>
          </svg>
        </span>
        <div class="pref-text">
          <span class="pref-label">Email notifications</span>
          <span class="pref-desc">Receive email updates for your ideas</span>
        </div>
        <button type="button" class="toggle" [class.on]="emailNotifications" (click)="toggleEmailNotifications()" [disabled]="savingPrefs" aria-label="Toggle email notifications">
          <span class="toggle-track"><span class="toggle-thumb"></span></span>
        </button>
      </div>
      <div class="pref-item">
        <span class="pref-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
            <path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"/>
          </svg>
        </span>
        <div class="pref-text">
          <span class="pref-label">Idea status changes</span>
          <span class="pref-desc">Get notified when your ideas change status</span>
        </div>
        <button type="button" class="toggle" [class.on]="ideaStatusChanges" (click)="toggleIdeaStatusChanges()" [disabled]="savingPrefs" aria-label="Toggle idea status notifications">
          <span class="toggle-track"><span class="toggle-thumb"></span></span>
        </button>
      </div>
      <div class="pref-item">
        <span class="pref-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
            <path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"/>
          </svg>
        </span>
        <div class="pref-text">
          <span class="pref-label">Comments on my ideas</span>
          <span class="pref-desc">Notify when someone comments on your idea</span>
        </div>
        <button type="button" class="toggle" [class.on]="newComments" (click)="toggleNewComments()" [disabled]="savingPrefs" aria-label="Toggle new comments notifications">
          <span class="toggle-track"><span class="toggle-thumb"></span></span>
        </button>
      </div>
      <div class="pref-item">
        <span class="pref-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
            <path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"/>
          </svg>
        </span>
        <div class="pref-text">
          <span class="pref-label">Followed idea updates</span>
          <span class="pref-desc">Updates for ideas you're following</span>
        </div>
        <button type="button" class="toggle" [class.on]="followedIdeaUpdates" (click)="toggleFollowedIdeaUpdates()" [disabled]="savingPrefs" aria-label="Toggle followed idea updates">
          <span class="toggle-track"><span class="toggle-thumb"></span></span>
        </button>
      </div>
      <div class="pref-item">
        <span class="pref-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
            <path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"/>
          </svg>
        </span>
        <div class="pref-text">
          <span class="pref-label">Challenge announcements</span>
          <span class="pref-desc">New challenges and deadlines</span>
        </div>
        <button type="button" class="toggle" [class.on]="challengeAnnouncements" (click)="toggleChallengeAnnouncements()" [disabled]="savingPrefs" aria-label="Toggle challenge announcements">
          <span class="toggle-track"><span class="toggle-thumb"></span></span>
        </button>
      </div>
      <div class="pref-item">
        <span class="pref-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
            <path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"/>
          </svg>
        </span>
        <div class="pref-text">
          <span class="pref-label">Weekly digest</span>
          <span class="pref-desc">Weekly summary of platform activity</span>
        </div>
        <button type="button" class="toggle" [class.on]="weeklyDigest" (click)="toggleWeeklyDigest()" [disabled]="savingPrefs" aria-label="Toggle weekly digest">
          <span class="toggle-track"><span class="toggle-thumb"></span></span>
        </button>
      </div>
        </div>
      </div>
    </div>
  </section> -->

  <div *ngIf="errorMessage" class="error-banner" role="alert">{{ errorMessage }}</div>
  <div *ngIf="loading" class="loading-state">
    <app-loader label="Loading ideas"></app-loader>
  </div>

  <div *ngIf="!loading && !errorMessage && ideas.length === 0" class="empty-state">
    <p>You're not following any ideas yet.</p>
    <p class="empty-hint">Find ideas on the feed and click the star to follow them.</p>
    <a routerLink="/feed" class="btn-primary">Browse Ideas</a>
  </div>

  <section *ngIf="!loading && ideas.length > 0" class="ideas-section">
    <h2 class="section-title">Following {{ totalCount }} ideas</h2>
    <div class="ideas-list">
      <article *ngFor="let idea of ideas" class="idea-card">
        <div class="idea-card-inner">
          <div [routerLink]="['/ideas', idea.id]" class="clickable-card">
            <h3 class="idea-title">{{ idea.title }}</h3>
            <p *ngIf="idea.description" class="idea-description">{{ idea.description }}</p>
            <div class="idea-tags">
              <span class="tag" [ngClass]="getStatusClass(idea.status)">{{ getStatusLabel(idea.status) }}</span>
              <span class="tag tag-category">{{ idea.category.name }}</span>
              <span *ngIf="idea.challengeTitle" class="tag tag-challenge">{{ idea.challengeTitle }}</span>
            </div>
            <div class="idea-footer">
              <span class="idea-meta">
                by {{ idea.ownerDisplayName || 'Anonymous' }}{{ idea.createdAtUtc ? ' • ' + formatDate(idea.createdAtUtc) : '' }}
              </span>
              <button
                type="button"
                class="btn-unfollow"
                (click)="unfollow(idea); $event.stopPropagation()"
                [disabled]="savingUnfollowId === idea.id"
              >
                <svg class="star-icon" viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
                  <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>
                </svg>
                Unfollow
              </button>
            </div>
          </div>
        </div>
      </article>
    </div>
  </section>
</div>
